<template>
    <IndexBase @auth="onAuth($event)" action="Index" controller="DocKomQc"></IndexBase>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            [{{ mode }}] Document Kick Off Meeting QC
                        </div>
                        <div style="margin-left: 10px" v-if="mode != this.$FORM_MODE_CREATE">
                            <Button type="button" icon="pi pi-info" @click="toggle" aria:haspopup="true"
                                aria-controls="overlay_panel" class="p-button-rounded p-button-outlined p-button-sm" />

                            <OverlayPanel ref="op" appendTo="body" :showCloseIcon="true" id="overlay_panel"
                                style="width: 550px" :breakpoints="{ '960px': '80vw' }">
                                <div class="grid field">
                                    <div class="row">
                                        <i class="pi pi-plus-circle" /> {{ this.$formatDateTime(header.Created_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Created_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Edited_Date">
                                    <div class="row">
                                        <i class="pi pi-pencil" /> {{ this.$formatDateTime(header.Edited_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Edited_By }}
                                    </div>
                                </div>
                                <div class="grid field" v-if="header.Deleted_Date">
                                    <div class="row">
                                        <i class="pi pi-trash" /> {{ this.$formatDateTime(header.Deleted_Date) }}
                                    </div>
                                    <div class="row">
                                        &nbsp;by {{ header.Deleted_By }}
                                    </div>
                                </div>
                            </OverlayPanel>
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Draft" class="p-button-secondary mr-2" @click="confirmDraft($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && (header && header.Status != this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL && header.Status != this.$APPROVAL_STATUS.APPROVED && header.Status != this.$APPROVAL_STATUS.DONE)"/> 
                        <Button icon="pi pi-upload" label="Save" class="p-button-success" @click="confirm($event)" v-if="mode != this.$FORM_MODE_DELETE && mode != this.$FORM_MODE_VIEW && !onlyDraft" />
                        <Button icon="pi pi-trash" label="Delete" class="p-button-danger" @click="confirm($event)"
                            v-if="mode == this.$FORM_MODE_DELETE" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">
                        
                            <!-- <FormField :labelName="$t('doc_no')" fieldName="Doc_No" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Doc_No" v-model="header.Doc_No" required="true" type="text"
                                    :placeholder="$t('doc_no')" v-if="header" 
                                    :disabled="true" />
                                  
                            </FormField> -->

                            <!-- <FormField :labelName="$t('no_spo')" fieldName="No_SPO" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="No_SPO" v-model="header.No_SPO" required="true" type="text"
                                    :placeholder="$t('no_spo')" v-if="header" 
                                    :disabled="true" />
                                    <small v-if="header && !header.No_SPO && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('no_spo')) }}
                                     </small>
                                     
                            </FormField>

                            <FormField :labelName="$t('project')" fieldName="Project" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Project" v-model="header.Project" required="true" type="text"
                                    :placeholder="$t('project')" v-if="header"
                                    :disabled="true" />
                                    <small v-if="header && !header.Project && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('project')) }}
                                     </small>
                            </FormField>


                            <FormField :labelName="$t('meeting_no')" fieldName="Meeting_No" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Meeting_No" v-model="header.Meeting_No" required="true" type="text"
                                    :placeholder="$t('meeting_no')" v-if="header"
                                    :disabled="true" />
                                    <small v-if="header && !header.Meeting_No && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('meeting_no')) }}
                                     </small>
                            </FormField> -->

                            <!-- <FormField :labelName="$t('date_of_meeting')" fieldName="Date_Of_Meeting" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <DatePicker name="date_of_meeting" v-model="header.Date_Of_Meeting" type="text"
                                :placeholder="$t('date_of_meeting')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" showTime hourFormat="24"/>
                                <small
                                    v-if="header && !header.Date_Of_Meeting && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('date_of_meeting')) }}
                                </small>
                            </FormField>

                            <FormField :labelName="$t('meeting_room')" fieldName="Meeting_Room" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Deskripsi_Pekerjaan" v-model="header.Meeting_Room" required="true" type="text"
                                    :placeholder="$t('meeting_room')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    <small v-if="header && !header.Meeting_Room && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('meeting_room')) }}
                                    </small>
                            </FormField> -->

                            <FormField :labelName="$t('documentation')" :fileModels="header.files_data" v-if="header" labelClass="col-4" fieldClass="col-6">
                                <CustomFileUpload
                                    :fileModels="viewFiles"
                                    :multiple="true" 
                                    :showUploadButton="false" 
                                    :showCancelButton="false" 
                                    :customUpload="false" 
                                    @select="onFileSelect" 
                                    @remove="onFileRemove" 
                                    :viewOnly="true" 
                                    :showHeader="false"
                                    :showremove="true"
                                    :disabledRemove="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                    @removefile="removeFile"
                                    @download="onDownloadFile"
                                    />                                   
                            </FormField>
                        
                            <FormField :labelName="''" :fileModels="header.files_data" v-model="header" v-if="header" fieldClass="col-6" labelClass="col-4">
                                <CustomFileUpload 
                                :fileModels="header.files_data"
                                :multiple="true" 
                                :maxFileSize="5242880"
                                :showUploadButton="false"
                                :showCancelButton="false" 
                                :customUpload="false" 
                                @select="onFileSelect($event, header)"
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                @remove="onFileRemove($event, header)" />
                            </FormField>
                            <!-- accept="image/*" -->
                        </div>  
                        <div class="col-6">
                          
                            <FormField :labelName="$t('status')" fieldName="Status" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Status" v-model="header.Status" required="true" type="text"
                                    :placeholder="$t('status')" v-if="header"
                                    :disabled="true" />
                            </FormField>

                            <FormField :labelName="$t('is_check')" fieldName="Is_Check" v-model="header" labelClass="col-4" fieldClass="col-6 md-6" v-if="header && header.User_Type != this.$USER_LEVEL.CONTRACTOR">
                                <Checkbox v-model="header.Is_Check" :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT || !this.$store.getters.getJobPosition.includes(this.$UserLevel.ADMIN_QC) || this.header.Status == this.$APPROVAL_STATUS.DONE" v-if="header" :binary="true"/>
                            </FormField>


                            <FormField :labelName="$t('notes')" fieldName="notes" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Notes" v-model="header.Notes" required="true" type="text"
                                    :placeholder="$t('notes')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                            </FormField> 

                            <FormField :labelName="$t('reason')" fieldName="Reason" v-model="header" labelClass="col-4" fieldClass="col-6" v-if="header && (header.Status == this.$APPROVAL_STATUS.DONE || header.Status == this.$APPROVAL_STATUS.WAITING_FOR_APPROVAL)">
                                <InputText name="Reason" v-model="header.Reason" required="true" type="text"
                                    :placeholder="$t('reason')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT|| header.Status != this.$APPROVAL_STATUS.DONE"/>
                                    <small v-if="header &&((!header.Reason && header.Status == this.$APPROVAL_STATUS.DONE)) && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                    </small>
                            </FormField>

                            <!-- <FormField :labelName="$t('notes_issued_by')" fieldName="Notes_Issued_By" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Deskripsi_Pekerjaan" v-model="header.Notes_Issued_By" required="true" type="text"
                                    :placeholder="$t('notes_issued_by')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    <small v-if="header && !header.Notes_Issued_By && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('notes_issued_by')) }}
                                    </small>
                            </FormField>

                            <FormField :labelName="$t('approved_by')" fieldName="Approved_By" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <InputText name="Approved_By" v-model="header.Approved_By" required="true" type="text"
                                    :placeholder="$t('approved_by')" v-if="header"
                                    :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    <small v-if="header && !header.Approved_By && submitted && mode != this.$FORM_MODE_DELETE"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('approved_by')) }}
                                    </small>
                            </FormField>

                            <FormField :labelName="$t('issued_date')" fieldName="Issued_Date" v-model="header" labelClass="col-4" fieldClass="col-6">
                                <DatePicker name="issued_date" v-model="header.Issued_Date" type="text"
                                :placeholder="$t('issued_date')" v-if="header" dateFormat="dd/mm/yyyy"
                                inputMask="99/99/9999" momentFormat="DD/MM/YYYY"
                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"/>
                                <small
                                    v-if="header && !header.Issued_Date && submitted && mode != this.$FORM_MODE_DELETE"
                                    class="p-error">{{ $t('is_required').replace('Value', $t('issued_date')) }}
                                </small>
                            </FormField> -->

                           
                        </div>
                        <!-- <div class="col-12">
                            <DataTable v-if="header" :loading="!header" :value="header.Items ? header.Items : null"
                                responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                <template #header>
                                    <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                                        <span class="text-900 font-bold">Item</span>
                                    </div>
                                </template>
                                <Column :exportable="false" style="width:30px">
                                    <template #header>
                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                            @click="addDetailItem()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    </template>
                                    <template #body="slotProps">
                                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                            @click="deleteDetailItem(slotProps)"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            v-show="slotProps.data.mode != 'Delete'" />
                                    </template>
                                </Column>
                                <Column field="Description_Discussions" :header="$t('description_discussions')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('description_discussions')" @change="onCellEditCompleteItem(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                                <br/>
                                                <small v-if="!slotProps.data.Description_Discussions && submitted && mode != this.$FORM_MODE_DELETE"
                                                    class="p-error">{{ $t('is_required').replace('Value', $t('description_discussions')) }}
                                                </small>
                                        </div>
                                    </template>
                                </Column>
                               
                                <Column field="Action_By" :header="$t('action_by')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('action_by')" @change="onCellEditCompleteItem(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                                <br/>
                                                <small v-if="!slotProps.data.Action_By && submitted && mode != this.$FORM_MODE_DELETE"
                                                    class="p-error">{{ $t('is_required').replace('Value', $t('action_by')) }}
                                                </small>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Date_Action_Required" :header="$t('date_action_required')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <DatePicker name="Date_Action_Required" v-model="slotProps.data[slotProps.column.props.field]"
                                            :placeholder="$t('date_action_required')" @input="onCellEditCompleteItem(slotProps)" @date-select="onCellEditCompleteItem(slotProps)"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            v-show="slotProps.data.mode != 'Delete'"/>
                                        
                                            <small v-if="!slotProps.data.Date_Action_Required && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('date_action_required')) }}
                                            </small>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Remark" :header="$t('remark')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('remark')" @change="onCellEditCompleteItem(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                                <br/>
                                                <small v-if="!slotProps.data.Remark && submitted && mode != this.$FORM_MODE_DELETE"
                                                    class="p-error">{{ $t('is_required').replace('Value', $t('remark')) }}
                                                </small>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                        <div class="col-6">
                            <DataTable v-if="header" :loading="!header" :value="header.AttendeCompanys ? header.AttendeCompanys : null"
                                responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                <template #header>
                                    <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                                        <span class="text-900 font-bold">Attendee Company Wilmar</span>
                                    </div>
                                </template>
                                <Column :exportable="false" style="width:30px">
                                    <template #header>
                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                            @click="addDetailComp()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    </template>
                                    <template #body="slotProps">
                                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                            @click="deleteDetailComp(slotProps)"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            v-show="slotProps.data.mode != 'Delete'" />
                                    </template>
                                </Column>
<Column field="Company_Name" :header="$t('company_name')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid" v-if="slotProps.index==0">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('company_name')" @change="onCellEditCompleteComp(slotProps)"
                                                :disabled="true"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                        </div>
                                    </template>
                                </Column> 

                                <Column field="Name" :header="$t('name')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('name')" @change="onCellEditCompleteComp(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                                <br/>
                                                <small v-if="!slotProps.data.Name && submitted && mode != this.$FORM_MODE_DELETE"
                                                    class="p-error">{{ $t('is_required').replace('Value', $t('name')) }}
                                                </small>
                                        </div>
                                    </template>
                                </Column>
                                <Column field="Dept" :header="$t('dept')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('dept')" @change="onCellEditCompleteComp(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                                <br/>
                                                <small v-if="!slotProps.data.Dept && submitted && mode != this.$FORM_MODE_DELETE"
                                                    class="p-error">{{ $t('is_required').replace('Value', $t('dept')) }}
                                                </small>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Job_Role" :header="$t('job_role')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('job_role')" @change="onCellEditCompleteComp(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                                <br/>
                                                <small v-if="!slotProps.data.Job_Role && submitted && mode != this.$FORM_MODE_DELETE"
                                                    class="p-error">{{ $t('is_required').replace('Value', $t('job_role')) }}
                                                </small>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Sign" :header="$t('sign')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('sign')" @change="onCellEditCompleteComp(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                        <div class="col-6">
                            <DataTable v-if="header" :loading="!header" :value="header.AttendeContractors ? header.AttendeContractors : null"
                                responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                                <template #header>
                                    <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                                        <span class="text-900 font-bold">Attendee Company Contractor</span>
                                    </div>
                                </template>
                                <Column :exportable="false" style="width:30px">
                                    <template #header>
                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                            @click="addDetailCont()"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT" />
                                    </template>
                                    <template #body="slotProps">
                                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                            @click="deleteDetailCont(slotProps)"
                                            :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                            v-show="slotProps.data.mode != 'Delete'" />
                                    </template>
                                </Column>
                               
                                <Column field="Company_Name" :header="$t('company_name')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid" v-if="slotProps.index==0">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('company_name')" @change="onCellEditCompleteComp(slotProps)"
                                                :disabled="true"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                        </div>
                                    </template>
                                </Column> 
                                
                                <Column field="Name" :header="$t('name')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('Name')" @change="onCellEditCompleteCont(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                            <br/>
                                            <small v-if="!slotProps.data.Name && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('name')) }}
                                            </small>
                                        </div>
                                    </template>
                                </Column>
                                <Column field="Job_Role" :header="$t('job_role')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('job_role')" @change="onCellEditCompleteCont(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                            <br/>
                                            <small v-if="!slotProps.data.Job_Role && submitted && mode != this.$FORM_MODE_DELETE"
                                                class="p-error">{{ $t('is_required').replace('Value', $t('job_role')) }}
                                            </small>
                                        </div>
                                    </template>
                                </Column>

                                <Column field="Sign" :header="$t('sign')" Key="Id">
                                    <template #body="slotProps">
                                        <div class="p-fluid">
                                            <InputText 
                                                v-model="slotProps.data[slotProps.column.props.field]" required="true"
                                                :placeholder="$t('sign')" @change="onCellEditCompleteCont(slotProps)"
                                                :disabled="mode != this.$FORM_MODE_CREATE && mode != this.$FORM_MODE_EDIT"
                                                v-show="slotProps.data.mode != 'Delete'" />
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>-->
                        <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                            <TabView>
                                <TabPanel :header="$t('log_history')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                        :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('Change_History')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                            </TabView>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </form>
</template>


<script>
import moment from 'moment';
import IndexBase from '../Helper/IndexBase.vue'
export default {
    name: "Editor",
    components: {
        IndexBase
    },
    data() {
        return {
            indexName: "DocKomQcIndex",
            url: this.$API_URL + "dockomqc/",
            header: null,
            detail: null,
            mode: "",
            submitted: false,
            id: 0,
            mainid : 0,
            formEditable: true,
            dataModelReqLogs: [],
            dataRequestLogs: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Action By" },
                { field: "Action", header: "Action" },
                { field: "Action_Date", header: "Action Date" },
                { field: "Notes", header: "Notes" },
            ],
            dataModelRelease: [],
            dataRelease: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Name" },
                { field: "Level", header: "Level" },
                { field: "Validity", header: "Validity" },
                { field: "Status", header: "Status" }
            ],
            viewFiles : null,
            item : null,
            attendecomp : null,
            attendecont : null,
            imgsrc : null,
            etailLog : null,
            dataChangesLog:this.$dataChangesLog,
            onlyDraft: false
        }
    },
    methods: {
        onAuth(event) {
            this.onlyDraft = event.onlyDraft;
        },  
        removeFile(event){
           var file = {...event};
            let self = this;
            this.$emit('block-ui');
            this.$axios.post(this.url+"removefile", file)
            .then((response) => {
                if (response.data.success) {
                    self.$toast.add({ severity: 'success', summary: "Success", detail: response.data.message, life: 3000 });
                    this.$emit('unblock-ui');
                    self.getData();
                }
                else {
                    self.showError('Error Saving Data', response.data.message);
                }
            })
            .catch(function (error) {
                self.showError('Error Saving Data', error);
            });
        },
        getData() {
            var self = this;
            this.$axios.get(this.url + this.mainid + "/" +this.id + "/" + this.mode)
                .then((response) => {
                    self.header = response.data.data.header;
                    self.header.mode = self.mode;
                    self.detail = response.data.data.detail;
                    self.dataModelReqLogs = response.data.data.header.request_log;
                    self.dataModelRelease = response.data.data.header.approval_log;
                    self.item = response.data.data.item;
                    self.attendecomp = response.data.data.attendecompany;
                    self.attendecont = response.data.data.attendecontractor;
                    self.detailLog = self.header.DetailLog;

                    if(self.header.Documentation){
                            var attachment = this.header.Documentation.split(';');
                            self.viewFiles = [];
                            attachment.forEach(a => {
                                if (a != '') {
                                    var name = a.split("/").at(-1);
                                    var d = {
                                        name: name,
                                        path: a,
                                        id: self.header.Id
                                    };

                                    self.viewFiles.push(d);
                                }
                            });
                        }
                })
                .catch(function (error) {
                    self.showError("Error", error);
                });
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;
            var data = new FormData();

            if(this.header.files_data != null)
                for(var x=0; x < this.header.files_data.length;x++){
                    var file = this.header.files_data[x];
                    data.append("attachments.File", file, file.name);
            }
            if(this.header.No_SPO != null)    
                data.append("No_SPO", this.header.No_SPO);
            //data.append("Project", this.header.Project);
            data.append("Id", this.header.Id);
            data.append("Main_Data_Id", this.header.Main_Data_Id);
            
            if(this.header.Meeting_No != null)
                data.append("Meeting_No", this.header.Meeting_No);

            if(this.header.Reason != null)
                data.append("Reason", this.header.Reason);

            if(this.header.Is_Check != null)
                data.append("Is_Check", this.header.Is_Check);
            else if(this.header.Is_Check == null)
                data.append("Is_Check", false);

            if(this.header.Notes != null)
                data.append("Notes", this.header.Notes);

                // data.append("Date_Of_Meeting1", moment(this.header.Date_Of_Meeting).format('YYYY/MM/DD HH:mm').toString());
                data.append("Company_Code", this.header.Company_Code);
                data.append("Location_Code", this.header.Location_Code);
                // data.append("Meeting_Room", this.header.Meeting_Room);
                // data.append("Notes_Issued_By", this.header.Notes_Issued_By);
                // data.append("Approved_By", this.header.Approved_By);
                // data.append("Issued_Date1",  moment(this.header.Issued_Date).format('YYYY/MM/DD').toString());
                data.append("mode", this.header.mode);
                if(this.header.Doc_No != null)
                    data.append("Doc_No", this.header.Doc_No);
                //data.append("Company_All", this.header.Company_All);
                
                // for(var i=0; i< this.header.Items.length;i++){
                //     var item = this.header.Items[i];
                //     if(item.mode != null)
                //         data.append("Items[" + i + "].mode", item.mode);
                //     if(item.Doc_Kick_Of_Meeting_Id != null)
                //         data.append("Items[" + i + "].Doc_Kick_Of_Meeting_Id", item.Doc_Kick_Of_Meeting_Id);
                //     if(item.Id != null)
                //         data.append("Items[" + i + "].Id", item.Id);
                //     if(item.Description_Discussions != null)
                //         data.append("Items[" + i + "].Description_Discussions", item.Description_Discussions);
                //     if(item.Action_By != null)
                //         data.append("Items[" + i + "].Action_By", item.Action_By);
                //     if(item.Date_Action_Required != null)
                //         data.append("Items[" + i + "].Date_Action_Required1",  moment(this.header.Date_Action_Required).format('YYYY/MM/DD').toString());
                //     if(item.Remark != null)
                //         data.append("Items[" + i + "].Remark", item.Remark);
                       
                // }

                // for(var j=0; j< this.header.AttendeCompanys.length;j++){
                //     var comp = this.header.AttendeCompanys[j];
                //     if(comp.mode != null)
                //         data.append("AttendeCompanys[" + j + "].mode", comp.mode);
                //     if(comp.Id != null)
                //         data.append("AttendeCompanys[" + j + "].Id", comp.Id);
                    
                //     if(comp.Doc_Kick_Of_Meeting_Id != null)
                //         data.append("AttendeCompanys[" + j + "].Doc_Kick_Of_Meeting_Id", comp.Doc_Kick_Of_Meeting_Id);
                //     if(comp.Name != null)
                //         data.append("AttendeCompanys[" + j + "].Name", comp.Name);
                //     if(comp.Dept != null)
                //         data.append("AttendeCompanys[" + j + "].Dept", comp.Dept);
                //     if(comp.Job_Role != null)
                //         data.append("AttendeCompanys[" + j + "].Job_Role", comp.Job_Role);
                //     if(comp.Sign != null)
                //         data.append("AttendeCompanys[" + j + "].Sign", comp.Sign);
                //     if(comp.Company_Name != null)
                //         data.append("AttendeCompanys[" + j + "].Company_Name", comp.Company_Name);
                // }

                // for(var k=0; k< this.header.AttendeContractors.length;k++){
                //     var cont = this.header.AttendeContractors[k];
                //     if(cont.mode != null)
                //         data.append("AttendeContractors[" + k + "].mode", cont.mode);
                //     if(cont.Id != null)
                //         data.append("AttendeContractors[" + k + "].Id", cont.Id);
                    
                //     if(cont.Doc_Kick_Of_Meeting_Id != null)
                //         data.append("AttendeContractors[" + k + "].Doc_Kick_Of_Meeting_Id", cont.Doc_Kick_Of_Meeting_Id);
                //     if(cont.Name != null)
                //         data.append("AttendeContractors[" + k + "].Name", cont.Name);
                //     if(cont.Job_Role != null)
                //         data.append("AttendeContractors[" + k + "].Job_Role", cont.Job_Role);
                //     if(cont.Sign != null)
                //         data.append("AttendeContractors[" + k + "].Sign", cont.Sign);
                //     if(cont.Company_Name != null)
                //         data.append("AttendeContractors[" + k + "].Company_Name", cont.Company_Name);
                // }
                
             this.$axios.post(this.url, data, 
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                .then((response) => {
                    if (response.data.success) {
                        if (this.mode == this.$FORM_MODE_DELETE) {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Deleted', detail: "Doc KOM has been deleted successfully", life: 3000 } });
                        } else {
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "Doc KOM has been saved successfully", life: 3000 } });
                        }

                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            if(this.$router.options.history.state.back != null)
                this.$router.push({ path: this.$router.options.history.state.back });
            else 
              this.$router.push({ path: "Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            var self = this;

            //!this.header.Doc_No || !this.header.Meeting_No ||
            // if (!this.header.Project || !this.header.Date_Of_Meeting || !this.header.Meeting_Room||
            //     !this.header.Notes_Issued_By || !this.header.Approved_By || !this.header.Issued_Date) {
            //     return;
            // }
           
            if(this.mode != this.$FORM_MODE_DELETE){
                if((!this.header.Reason && this.header.Status == this.$APPROVAL_STATUS.DONE)) return false;
            
                if(!self.header.Documentation && this.header.files_data == null){
                    self.showError("Error", "Must have attachment")
                    return;
                }
            }
            // if(this.header.Items.length == 0){
            //     self.showError("Error", "Must have one Item")
            //     return;
            // }
            // if(this.header.AttendeCompanys.length == 0){
            //     self.showError("Error", "Must have one Attende Companys")
            //     return;
            // }

            // if(this.header.AttendeContractors.length == 0){
            //     self.showError("Error", "Must have one Attende Contractors")
            //     return;
            // }
           

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        confirmDraft(event) {
            this.submitted = true;
            var self = this;

            //!this.header.Doc_No ||!this.header.Meeting_No ||
            // if (!this.header.Project || !this.header.Date_Of_Meeting || !this.header.Meeting_Room||
            //     !this.header.Notes_Issued_By || !this.header.Approved_By || !this.header.Issued_Date) {
            //     return;
            // }
           
            // if(this.header.files_data == null && this.mode == this.$FORM_MODE_CREATE){
            //     self.showError("Error", "Must have attachment")
            //     return;
            // }   
            
            // if(this.header.Items.length == 0){
            //     self.showError("Error", "Must have one Item")
            //     return;
            // }
            // if(this.header.AttendeCompanys.length == 0){
            //     self.showError("Error", "Must have one Attende Companys")
            //     return;
            // }

            // if(this.header.AttendeContractors.length == 0){
            //     self.showError("Error", "Must have one Attende Contractors")
            //     return;
            // }

            // if(this.header.files_data == null && this.mode == this.$FORM_MODE_CREATE){
            //     self.showError("Error", "Must have attachment")
            //     return;
            // }   

            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure save as draft ?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if(this.mode == this.$FORM_MODE_CREATE)
                        this.header.mode = this.$FORM_MODE_DRAFT;
                    else if(this.mode == this.$FORM_MODE_EDIT)
                            this.header.mode = this.$FORM_MODE_DRAFT_EDIT;
                    else
                        this.header.mode = this.mode;
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetailItem() {
            var newDetail = this.item;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.Items.push(det);
        },
        deleteDetailItem(event) {
            if (event) {
                var detail = this.header.Items[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.Items.splice(this.header.Items.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditCompleteItem(event) {
            this.editDetailItem(event.index);
        },
        editDetailItem(index) {
            if (this.header && this.header.Items) {
                let mode = this.header.Items[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.Items[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        addDetailComp() {
            var newDetail = this.attendecomp;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.AttendeCompanys.push(det);
        },
        deleteDetailComp(event) {
            if (event) {
                var detail = this.header.AttendeCompanys[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.AttendeCompanys.splice(this.header.AttendeCompanys.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditCompleteComp(event) {
            this.editDetailComp(event.index);
        },
        editDetailComp(index) {
            if (this.header && this.header.AttendeCompanys) {
                let mode = this.header.AttendeCompanys[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.AttendeCompanys[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        addDetailCont() {
            var newDetail = this.attendecont;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.AttendeContractors.push(det);
        },
        deleteDetailCont(event) {
            if (event) {
                var detail = this.header.AttendeContractors[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.AttendeContractors.splice(this.header.AttendeContractors.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditCompleteCont(event) {
            this.editDetailCont(event.index);
        },
        editDetailCont(index) {
            if (this.header && this.header.AttendeContractors) {
                let mode = this.header.AttendeContractors[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.AttendeContractors[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        onFileRemove(files,data) {
                data.files_data = [];
                for(var i = 0; i<files.length;i++){
                    data.files_data.push(event.files[i]);
                }
        },
        onFileSelect(event, data) {
                data.files_data = [];
                for(var i = 0; i<event.files.length;i++){
                    data.files_data.push(event.files[i]);
                }
        },
        onFileSelectUpload(event) {
            this.detailFiles = event.files;
            this.uploadFile = true;
        },
        async onDownloadFile(file){
            var self = this;
            try{
                let response = await this.$axios.get(this.url + "download_attachment/" + file.id + "/" + file.name, {responseType: 'blob', timeout: this.$AXIOS_TIMEOUT_LONG})
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const dataUrl = await this.renderBlobToDataURL(new Blob([response.data], {type: 'image/png'}));
                this.imgsrc = dataUrl;
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', file.name);
                document.body.appendChild(link);
                link.click();
            }catch(err){
                self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: "File not found" + err, life: 120000});
                self.blocked = false;
            }
        },
       async renderBlobToDataURL(blob) {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (event) => {
            resolve(event.target.result);
            };
            reader.readAsDataURL(blob);
      });
    }
        
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;
        this.mainid = this.$route.query.mainid ?? 0;
        this.getData();
        if(this.$router.options.history.state.back != null){
            var indexName = this.$router.options.history.state.back.split("/");
            if(indexName[1] == "MainData")
                this.indexName = "MainDataIndex";
        }
    
    }
}
</script>